// We enforce not to import MUI `Dialog` so all Dialog
// components will use this component. Thus we need to disable the lint rule.
// eslint-disable-next-line no-restricted-imports
import { Dialog as MuiDialog, DialogProps } from '@material-ui/core';
import { css } from '@emotion/react';

import { useColors } from 'hooks/useColors';
import { IColors } from 'types/colors';
// import { colors } from 'styles/theme';
import { setOpacity } from 'styles/utils';
import { forwardRef } from 'react';

const dialogCss = (colors: IColors) => css`
	.MuiBackdrop-root {
		background-color: ${setOpacity(colors.bg_white || '', 0.7)};
	}

	.MuiPaper-root {
		box-shadow: 0 2px 22px 8px ${setOpacity(colors.bg_text_primary || '', 0.08)};
	}
`;

/**
 * Material UI Dialog Wrapper
 *
 * @see
 * [Dialog](https://material-ui.com/components/dialogs/)
 * @see
 * [Dialog API](https://material-ui.com/api/dialog/)
 */

const Dialog = forwardRef<HTMLDivElement | undefined | unknown, DialogProps>(
	({ children, ...restProps }, ref = null) => {
		const { colors } = useColors();
		return (
			<MuiDialog ref={ref} css={dialogCss(colors)} {...restProps}>
				{children}
			</MuiDialog>
		);
	}
);
Dialog.displayName = 'Dialog';
export default Dialog;
